import React, { Component } from "react";
import { Collapse } from "react-bootstrap";
import { NavLink } from "react-router-dom";
// this is used to create scrollbars on windows devices like the ones from apple devices
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { Grid, Row, Modal, Col } from "react-bootstrap";
import * as userService from "../../services/userServices";
import * as pegawaiService from "../../services/pegawaiServices";
//import HeaderLinks from "components/Header/HeaderLinks.jsx";
import { imagesFile } from "../../services/config.json";
// backgroundImage for Sidebar
import image from "assets/img/full-screen-image-3.jpg";
// image for avatar in Sidebar
// logo for sidebar
//import logo from "logo.svg";

import dashboardRoutes from "routes/dashboard.jsx";

import auth from "../../services/authService";
import Input from "../Common/input";
const bgImage = { backgroundImage: "url(" + image + ")" };

var ps;
var base64 = require("base-64");
class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openAvatar: false,
      openComponents: this.activeRoute("/components") !== "" ? true : false,
      openForms: this.activeRoute("/forms") !== "" ? true : false,
      openTables: this.activeRoute("/tables") !== "" ? true : false,
      openMaps: this.activeRoute("/maps") !== "" ? true : false,
      openPages: this.activeRoute("/pages") !== "" ? true : false,
      isWindows: navigator.platform.indexOf("Win") > -1 ? true : false,
      width: window.innerWidth,
      openModal: false,
      oldPassword: "",
      newPassword: "",
      confPassword: "",
      respond: "",
      passwordType: ""
    };
  }
  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  // if the windows width changes CSS has to make some changes
  // this functions tell react what width is the window
  updateDimensions() {
    this.setState({ width: window.innerWidth });
  }
  componentDidMount() {
    this.updateDimensions();
    this.mount = true;
    // add event listener for windows resize
    window.addEventListener("resize", this.updateDimensions.bind(this));
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.sidebarWrapper, {
        suppressScrollX: true,
        suppressScrollY: false
      });
    }
    this.initAkses();
  }
  onOpenModal = () => {
    if (this.mount)
      this.setState({ openModal: true, passwordType: "username" });
  };
  componentDidUpdate() {
    if (navigator.platform.indexOf("Win") > -1) {
      setTimeout(() => {
        ps.update();
      }, 350);
    }
    this.initAkses();
  }
  initAkses = async () => {
    await pegawaiService.getAllAkses().then((data) => {
      if (data.is_update === "1") {
        const akses = base64.encode(JSON.stringify(data.akses));
        localStorage.setItem("akses_report", akses);
      }
      if(!data.logged){
        this.handleLogout();
      }
    });
  };
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }
  handleLogout = () => {
    auth.logout(this);
  };
  handleChangePassword = ({ currentTarget: input }, target) => {
    let val = input.value;
    if (target === "oldpass") {
      if (this.mount) this.setState({ oldPassword: val });
    } else if (target === "newpass") {
      if (this.mount) this.setState({ newPassword: val });
    } else if (target === "confpass") {
      if (this.mount) this.setState({ confPassword: val });
    }
  };
  handleUpdatePassword = async () => {
    const { oldPassword, newPassword, confPassword, passwordType } = this.state;
    let id_customer = auth.getCurrentIdCustomer();
    if (passwordType === "username") {
      await userService
        .updatePassword(id_customer, oldPassword, newPassword, confPassword)
        .then(data => {
          if (this.mount)
            this.setState({
              openModal: false,
              openModalNotif: true,
              respond: data.res,
              oldPassword: "",
              newPassword: "",
              confPassword: ""
            });
        });
    }
  };
  render() {
    const {
      openModal,
      oldPassword,
      newPassword,
      confPassword,
      respond,
      passwordType,
      openModalNotif
    } = this.state;
    return (
      <div className="sidebar" data-color="black" data-image={image}>
        <div className="sidebar-background" style={bgImage} />
        <div className="logo">
          <a href="" className="simple-text logo-mini">
            <div className="logo-img">
              <img
                style={{ top: "0px" }}
                alt=""
                src={imagesFile + "logo.png"}
              />
            </div>
          </a>
          <a
            href=""
            className="simple-text logo-normal"
            style={{ fontSize: "16px", textAlign: "center" }}
          >
            {/*<img
              alt=""
              style={{ width: "70%" }}
              src="http://picture.hpmindonesia.co.id/pictures/text-logo.png"
            />*/}
            Interbrucke
            <br />
            Perkasa
          </a>
        </div>
        <div className="sidebar-wrapper" ref="sidebarWrapper">
          <div className="user">
            <div className="info text-center">
              <a
                onClick={() =>
                  this.setState({ openAvatar: !this.state.openAvatar })
                }
              >
                <span>
                  {auth.getCurrentUser()}
                  <b
                    className={
                      this.state.openAvatar ? "caret rotate-180" : "caret"
                    }
                  />
                </span>
              </a>
              <Collapse in={this.state.openAvatar}>
                <ul className="nav">
                  <li onClick={() => this.onOpenModal()}>
                    <a>
                      <span className="sidebar-normal">Change Password</span>
                    </a>
                  </li>
                  <li onClick={() => this.handleLogout()}>
                    <a>
                      <span className="sidebar-normal">Log Out</span>
                    </a>
                  </li>
                </ul>
              </Collapse>
            </div>
          </div>

          <ul className="nav">
            {/* If we are on responsive, we want both links from navbar and sidebar
                            to appear in sidebar, so we render here HeaderLinks */}
            {/*this.state.width <= 992 ? <HeaderLinks /> : null*/}
            {/*
                            here we render the links in the sidebar
                            if the link is simple, we make a simple link, if not,
                            we have to create a collapsible group,
                            with the speciffic parent button and with it's children which are the links
                        */}
            {dashboardRoutes.map((prop, key) => {
              var st = {};
              st[prop["state"]] = !this.state[prop.state];
              if (prop.topcollapse && !prop.hidden) {
                return (
                  <li className={this.activeRoute(prop.path)} key={key}>
                    <a onClick={() => this.setState(st)}>
                      <i className={prop.icon} />
                      <p>
                        {prop.name}
                        <b
                          className={
                            this.state[prop.state]
                              ? "caret rotate-180"
                              : "caret"
                          }
                        />
                      </p>
                    </a>
                    <Collapse in={this.state[prop.state]}>
                      <ul className="nav" style={{ paddingLeft: "15px" }}>
                        {prop.childs.map((prop, key) => {
                          var st = {};
                          st[prop["state"]] = !this.state[prop.state];
                          if (prop.collapse && !prop.hidden) {
                            return (
                              <React.Fragment key={key}>
                                {((prop.modul &&
                                  auth.getAkses(
                                    prop.modul,
                                    prop.modulAction
                                  ) === "1") ||
                                  !prop.modul) && (
                                  <li
                                    className={this.activeRoute(prop.path)}
                                    key={key}
                                    data-tip={
                                      prop.tooltip ? prop.tooltip : null
                                    }
                                  >
                                    <a onClick={() => this.setState(st)}>
                                      <i className={prop.icon} />
                                      <p>
                                        {prop.name}
                                        <b
                                          className={
                                            this.state[prop.state]
                                              ? "caret rotate-180"
                                              : "caret"
                                          }
                                        />
                                      </p>
                                    </a>
                                    <Collapse in={this.state[prop.state]}>
                                      <ul className="nav">
                                        {prop.views.map((prop, key) => {
                                          return (
                                            <React.Fragment key={key}>
                                              {prop.modul ? (
                                                <React.Fragment>
                                                  {auth.getAkses(
                                                    prop.modul,
                                                    prop.modulAction
                                                  ) === "1" &&
                                                    !prop.hidden && (
                                                      <li
                                                        className={this.activeRoute(
                                                          prop.path
                                                        )}
                                                      >
                                                        <NavLink
                                                          to={prop.path}
                                                          className="nav-link"
                                                          activeClassName="active"
                                                        >
                                                          <span className="sidebar-mini">
                                                            {prop.mini}
                                                          </span>
                                                          <span className="sidebar-normal">
                                                            {prop.name}
                                                          </span>
                                                        </NavLink>
                                                      </li>
                                                    )}
                                                </React.Fragment>
                                              ) : (
                                                <React.Fragment>
                                                  {!prop.hidden && (
                                                    <li
                                                      className={this.activeRoute(
                                                        prop.path
                                                      )}
                                                    >
                                                      <NavLink
                                                        to={prop.path}
                                                        className="nav-link"
                                                        activeClassName="active"
                                                      >
                                                        <span className="sidebar-mini">
                                                          {prop.mini}
                                                        </span>
                                                        <span className="sidebar-normal">
                                                          {prop.name}
                                                        </span>
                                                      </NavLink>
                                                    </li>
                                                  )}
                                                </React.Fragment>
                                              )}
                                            </React.Fragment>
                                          );
                                        })}
                                      </ul>
                                    </Collapse>
                                  </li>
                                )}
                              </React.Fragment>
                            );
                          } else {
                            if (prop.redirect || prop.hidden) {
                              return null;
                            } else {
                              return (
                                <li
                                  className={this.activeRoute(prop.path)}
                                  key={key}
                                  data-tip={prop.tooltip ? prop.tooltip : null}
                                >
                                  <NavLink
                                    to={prop.path}
                                    className="nav-link"
                                    activeClassName="active"
                                  >
                                    <i className={prop.icon} />
                                    <p>{prop.name}</p>
                                  </NavLink>
                                </li>
                              );
                            }
                          }
                        })}
                      </ul>
                    </Collapse>
                  </li>
                );
              } else if (prop.collapse && !prop.hidden) {
                return (
                  <React.Fragment key={key}>
                    {((prop.modul &&
                      auth.getAkses(prop.modul, prop.modulAction) === "1") ||
                      !prop.modul) && (
                      <li
                        className={this.activeRoute(prop.path)}
                        key={key}
                        data-tip={prop.tooltip ? prop.tooltip : null}
                      >
                        <a onClick={() => this.setState(st)}>
                          <i className={prop.icon} />
                          <p>
                            {prop.name}
                            <b
                              className={
                                this.state[prop.state]
                                  ? "caret rotate-180"
                                  : "caret"
                              }
                            />
                          </p>
                        </a>
                        <Collapse in={this.state[prop.state]}>
                          <ul className="nav">
                            {prop.views.map((prop, key) => {
                              return (
                                <React.Fragment key={key}>
                                  {prop.modul ? (
                                    <React.Fragment>
                                      {auth.getAkses(
                                        prop.modul,
                                        prop.modulAction
                                      ) === "1" &&
                                        !prop.hidden && (
                                          <li
                                            className={this.activeRoute(
                                              prop.path
                                            )}
                                          >
                                            <NavLink
                                              to={prop.path}
                                              className="nav-link"
                                              activeClassName="active"
                                            >
                                              <span className="sidebar-mini">
                                                {prop.mini}
                                              </span>
                                              <span className="sidebar-normal">
                                                {prop.name}
                                              </span>
                                            </NavLink>
                                          </li>
                                        )}
                                    </React.Fragment>
                                  ) : (
                                    <React.Fragment>
                                      {!prop.hidden && (
                                        <li
                                          className={this.activeRoute(
                                            prop.path
                                          )}
                                        >
                                          <NavLink
                                            to={prop.path}
                                            className="nav-link"
                                            activeClassName="active"
                                          >
                                            <span className="sidebar-mini">
                                              {prop.mini}
                                            </span>
                                            <span className="sidebar-normal">
                                              {prop.name}
                                            </span>
                                          </NavLink>
                                        </li>
                                      )}
                                    </React.Fragment>
                                  )}
                                </React.Fragment>
                              );
                            })}
                          </ul>
                        </Collapse>
                      </li>
                    )}
                  </React.Fragment>
                );
              } else {
                if (prop.redirect || prop.hidden) {
                  return null;
                } else {
                  return (
                    <li
                      className={this.activeRoute(prop.path)}
                      key={key}
                      data-tip={prop.tooltip ? prop.tooltip : null}
                    >
                      <NavLink
                        to={prop.path}
                        className="nav-link"
                        activeClassName="active"
                      >
                        <i className={prop.icon} />
                        <p>{prop.name}</p>
                      </NavLink>
                    </li>
                  );
                }
              }
            })}
          </ul>
        </div>

        <Modal
          show={openModal}
          onHide={() => this.setState({ openModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {passwordType === "username" ? (
                <span>Change Password</span>
              ) : (
                <span>Change Password SC Approval</span>
              )}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ height: "400px", overflow: "auto" }}>
            <Grid fluid>
              <Row>
                <Col md={12}>
                  <Input
                    name="oldp"
                    type="password"
                    onChange={e => this.handleChangePassword(e, "oldpass")}
                    value={oldPassword}
                    label="Old Password :"
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Input
                    name="newp"
                    type="password"
                    onChange={e => this.handleChangePassword(e, "newpass")}
                    value={newPassword}
                    label="New Password :"
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Input
                    name="confp"
                    type="password"
                    onChange={e => this.handleChangePassword(e, "confpass")}
                    value={confPassword}
                    label="Confirm Password :"
                  />
                </Col>
              </Row>
            </Grid>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-fill btn-secondary"
              onClick={() => this.setState({ openModal: false })}
            >
              Close
            </button>
            <button
              className="btn btn-fill btn-primary"
              onClick={() => {
                this.handleUpdatePassword();
              }}
            >
              Update
            </button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={openModalNotif}
          onHide={() => this.setState({ openModalNotif: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Notification</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Grid fluid>
              <Row>
                <Col md={12}>{respond}</Col>
              </Row>
            </Grid>
          </Modal.Body>
          <Modal.Footer />
        </Modal>
      </div>
    );
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.jsx